import React from 'react';

import { Row } from '@opendoor/atoms/box';
import { Text } from '@opendoor/atoms/text';
import { cn } from '@opendoor/atoms/utils';
import { IconChevronRight } from '@tabler/icons-react';

interface MobileMegaNavButtonProps {
  itemName: string;
  onClick: () => void;
  isLast?: boolean;
}

export const MobileMegaNavButton: React.FC<MobileMegaNavButtonProps> = ({
  itemName,
  onClick,
  isLast,
}) => {
  return (
    <Text
      as="li"
      className={cn('border-od-border-secondary min-[1024px]:hidden', !isLast && 'border-b')}
    >
      <Row
        onClick={onClick}
        aria-label={itemName}
        className="w-full cursor-pointer appearance-none items-center justify-between border-0 bg-transparent py-4"
      >
        <Text as="span" className="text-lg leading-[1.45] tracking-[-0.024em]">
          {itemName}
        </Text>
        <IconChevronRight size={24} className="text-od-content-primary" aria-hidden="true" />
      </Row>
    </Text>
  );
};
